import {DatevWizardConfigDetailsState} from './datev-wizard-config-details.state';


export const datevWizardConfigDetailsStateInitial: DatevWizardConfigDetailsState = {
  isConnecting: false,
  isDisconnecting: false,
  isDeleting: false,
  isUpdatingConfiguration: false,
  connectionError: undefined,
  disconnectionError: undefined,
  deletionError: undefined,
  updateConfigurationError: undefined,
  errorEventsPage: undefined,
};
